module.exports = __webpack_public_path__ + "media/images/new/icons/notebook-f63f0f2d864fb03ea6fe172f86c140b4.png";